import { useQuery } from 'react-query';
import { fetchGymNewsFeed } from '../fetchers/news-feed';

export const useNewsFeed = (gymUid) => {
  const { isLoading, error, data } = useQuery(
    ['news-feed', gymUid],
    () => fetchGymNewsFeed(gymUid),
    {
      enabled: !!gymUid,
      refetchOnWindowFocus: false,
    }
  );

  return {
    posts: data || [],
    postsLoading: isLoading,
    error,
  };
};

